import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=2e7146fa&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=ts&"
export * from "./Step2.vue?vue&type=script&lang=ts&"
import style0 from "./Step2.vue?vue&type=style&index=0&id=2e7146fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7146fa",
  null
  
)

export default component.exports